module.exports = __webpack_public_path__ + "img/44dc772259604c9cbb4e995c8167213d.112a14d5.png";